import { alpha } from '@mui/material';

export const MuiFormLabelConfig = {
    styleOverrides: {
        root: ({ theme }: { theme: any }) => {
            return {
                color: theme.palette.text.primary,
                lineHeight: theme.size.lineHeight,
                marginBottom: theme.spacing(0.5),

                '&.design-variant--secondary, .design-variant--secondary &': {
                    lineHeight: 1.63636364, //18 from 11
                    marginBottom: theme.spacing(0.25),
                    fontSize: theme.size.pxValue(theme.typography.body1.fontSize - 1),
                    color: alpha(theme.palette.text.primary, 0.8),
                    '&.Mui-focused': {
                        color: theme.palette.primary.main,
                    },
                    '&.Mui-error': {
                        color: theme.palette.text.primary,
                        '&.Mui-focused': {
                            color: theme.palette.error.main,
                        },
                    },
                },
                '&.Mui-error': {
                    color: theme.palette.text.primary,
                    '&.Mui-focused': {
                        color: theme.palette.error.main,
                    },
                },
            };
        },
    },
};
